<template>
  <td v-if="renderCell" class="expand-template" :class="className">
    <base-icon-clickable class="m-auto" :name="expanded ? 'chevronup' : 'chevrondown'" size="sm" @click.stop="$emit('expandchange', { dataItem, event: $event, field, value: !expanded })" />
  </td>
  <td v-else-if="renderArrow" :key="`g-${columnIndex}`" class="k-group-cell" :class="className" />
  <td v-else-if="renderGroup" key="g-colspan" class="expand-template" :colSpan="columnsCount - columnIndex" :class="className">
    <p class="k-reset">
      <a @click="$emit('click', $event, dataItem, expanded)" tabIndex="-1" href="#" class="k-icon" :class="expanded ? 'k-i-collapse' : 'k-i-expand'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'
import NULL from '@/constants/NULL'

export default {
  name: 'expand-template',
  props: {
    tableId: [String, Number],
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    type: {
      type: String,
      default: 'Text'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {}
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    renderGroup () {
      return this.columnIndex <= this.level
    },
    value: function () {
      const value = getNestedValue(this.field, this.dataItem)
      return value === NULL ? null : value
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      if (value === null || value === undefined) return '' 
      return value 
    }
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
